import React from 'react'

const AlertRedIcon = () => {
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6791_19518)">
                <path d="M16.5996 13.8228L10.6662 3.43947C10.5368 3.21119 10.3492 3.02131 10.1225 2.88921C9.89581 2.7571 9.63811 2.6875 9.37572 2.6875C9.11333 2.6875 8.85563 2.7571 8.62892 2.88921C8.40221 3.02131 8.21459 3.21119 8.08522 3.43947L2.15189 13.8228C2.02112 14.0493 1.95255 14.3063 1.95313 14.5678C1.95371 14.8293 2.02342 15.086 2.15519 15.3119C2.28696 15.5378 2.47611 15.7249 2.70346 15.8541C2.93082 15.9833 3.1883 16.0502 3.44981 16.0478H15.3165C15.5767 16.0475 15.8323 15.9788 16.0576 15.8485C16.2829 15.7182 16.4699 15.5309 16.5999 15.3055C16.7299 15.08 16.7984 14.8243 16.7983 14.5641C16.7982 14.3038 16.7297 14.0482 16.5996 13.8228Z" stroke="#FF0500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.38281 7.14844V10.1151" stroke="#FF0500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.38281 13.0859H9.39023" stroke="#FF0500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_6791_19518">
                    <rect width="17.8" height="17.8" fill="white" transform="translate(0.484375 0.476562)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default AlertRedIcon
